
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NursingTaskList',
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        title: 'Date',
        align: 'start',
        sortable: false,
        key: 'date',
      },
      { title: 'Time', key: 'time' },
      { title: 'Description', key: 'description', sortable: false  },
      { title: 'Actioned', key: 'checked', sortable: false },
    ],
    orders: [],
    editedIndex: -1,
    editedItem: {
      date: '',
      time: '',
      type: '',
      description: '',
      content: '',
      checked: false
    },
    defaultItem: {
      date: '',
      time: '',
      description: '',
      content: '',
      checked: false
    },
  }),

  computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New Documents' : 'Edit Document'
      },
    },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.orders = [
        {
          date: '2023-04-01',
          time: '11:00',
          description: 'Reassess Pressure on Injury',
          checked: false
        },
        {
          date: '2023-04-01',
          time: '12:00',
          description: 'Administer Panadol',
          checked: false
        },
        {
          date: '2023-04-01',
          time: '12:00',
          description: 'Check Vitals',
          checked: false
        }
      ]
    },

    editItem (item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.orders.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.orders.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.orders[this.editedIndex], this.editedItem)
      } else {
        this.orders.push(this.editedItem)
      }
      this.close()
    },

    onUpdateDocument(value) {
      this.editedItem = value
    },
  },

})
